import ReactPDF, { Image, Text, View } from "@react-pdf/renderer";
import React from "react";
import { OrderStatus, TApiOrderDetails } from "../../../api/endpoints/Order";
import OrderStatusLabel from "../../../constants/OrderStatusLabel";
import logo from '../../../images/ecmwf-logo.png'

interface IProps {
  order: TApiOrderDetails;
  styles: ReactPDF.Styles;
}

const imageToBuffer = (image: string) => {
  const base64result = image.split(',')[1];

  return Buffer.from(base64result, 'base64');
}

const OrderPDFHeader = (props: IProps) => {
  const { order, styles } = props;

  const statusText = OrderStatusLabel.get(order.status);

  const statusClass = Object.fromEntries<ReactPDF.Style>([
    [OrderStatus.ACCEPTED, styles.accepted],
    [OrderStatus.COMPLETED, styles.accepted],
    [OrderStatus.SUBMITTED, styles.pending],
    [OrderStatus.ACTION_REQUIRED, styles.pending],
    [OrderStatus.DRAFT, styles.pending],
    [OrderStatus.REJECTED, styles.cancelled],
    [OrderStatus.CANCELLED, styles.cancelled]
  ]);

  return (
    <View style={[styles.heading, styles.flexRow, styles.flexStretch, styles.alignCenter]}>
      <View style={[styles.mainLogo, styles.noMargin]}>
        <Image source={{ data: imageToBuffer(logo), format: 'png' }} />
      </View>

      <View style={[styles.status, statusClass[order.status], styles.noMargin]}>
        <Text style={[styles.noMargin, styles.test]}>{statusText}</Text>
      </View>
    </View>
  );
};

export default OrderPDFHeader;
